var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 23,
  viewBox: "0 0 17 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 6.21v1h4V22H1V7h4V6H0v17h17V6.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.02 1.91v13.4h1V1.91l2.33 2.33.7-.7L8.52 0 4.98 3.54l.71.7z"
}))));
export default SvgUpload;